var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftExcelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H46V38C46 38.5304 45.7893 39.0391 45.4142 39.4142C45.0391 39.7893 44.5304 40 44 40H12C11.4696 40 10.9609 39.7893 10.5858 39.4142C10.2107 39.0391 10 38.5304 10 38V9Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H28V10H10V2C10 1.46957 10.2107 0.960859 10.5858 0.585786C10.9609 0.210714 11.4696 0 12 0Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H44C44.5304 0 45.0391 0.210714 45.4142 0.585786C45.7893 0.960859 46 1.46957 46 2V10H28V0Z",
    fill: "#33C481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H10V20H28V10Z",
    fill: "#107C41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10H28V20H46V10Z",
    fill: "#21A366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20H28V30H46V20Z",
    fill: "#107C41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 11H10V33H22C22.5304 33 23.0391 32.7893 23.4142 32.4142C23.7893 32.0391 24 31.5304 24 31V13C24 12.4696 23.7893 11.9609 23.4142 11.5858C23.0391 11.2107 22.5304 11 22 11Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H2C0.89543 9 0 9.89543 0 11V29C0 30.1046 0.89543 31 2 31H20C21.1046 31 22 30.1046 22 29V11C22 9.89543 21.1046 9 20 9Z",
    fill: "#148349"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39599 13.375H8.56299L11.125 18.479L13.896 13.375H16.813L12.792 19.979L16.938 26.625H13.833L11 21.313L8.18799 26.625H5.06299L9.29199 19.979L5.39599 13.375Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcelIcon);
export default __webpack_public_path__ + "static/media/microsoft-excel-icon.81df4aba990d6286a8c22f40755d72e4.svg";
export { ForwardRef as ReactComponent };